(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claudevideo"] && !Shopify.designMode) return;
  try {
    

class VideoPlayer extends HTMLElement {
  connectedCallback() {
    this.isPlaying = false;
    this.started   = false;
    this.source    = this.dataset.source;

    this.videoEl   = this.querySelector('video');
    this.iframeEl  = this.querySelector('iframe');
    this.cover     = this.querySelector('[data-cover]');
    this.toggleBtn = this.querySelector('[data-toggle-btn]');
    this.playIcon  = this.querySelector('[data-play-icon]');
    this.pauseIcon = this.querySelector('[data-pause-icon]');

    this.toggleBtn?.addEventListener('click', () => this.toggle());

    // Native <video> events are the source of truth for uploaded video
    if (this.videoEl) {
      this.videoEl.addEventListener('play',  () => this.setState(true));
      this.videoEl.addEventListener('pause', () => this.setState(false));
      this.videoEl.addEventListener('ended', () => this.setState(false));
    }

    // iframe player state via postMessage
    window.addEventListener('message', (e) => this.onMessage(e));

    // Autoplay — just sync the UI, the video/iframe handles itself
    if (this.dataset.autoplay === 'true') {
      this.started = true;
      this.setState(true);
    }
  }

  onMessage(e) {
    if (!this.iframeEl) return;
    try {
      const d = JSON.parse(e.data);
      // YouTube state: 1 = playing, 2 = paused, 0 = ended
      if (d.event === 'onStateChange') {
        if (d.info === 1) this.setState(true);
        if (d.info === 2 || d.info === 0) this.setState(false);
      }
      // Vimeo events
      if (d.event === 'play')  this.setState(true);
      if (d.event === 'pause' || d.event === 'ended') this.setState(false);
    } catch (_) {}
  }

  toggle() {
    if (!this.started) {
      this.start();       // first play — remove cover, load deferred iframe
    } else if (this.isPlaying) {
      this.pause();
    } else {
      this.play();
    }
  }

  start() {
    this.started = true;

    // Fade and remove cover image
    if (this.cover) {
      this.cover.style.opacity = '0';
      this.cover.style.pointerEvents = 'none';
      setTimeout(() => { if (this.cover) this.cover.style.display = 'none'; }, 260);
    }

    // Deferred iframe: set src now (URL already has autoplay=1 baked in)
    if (this.iframeEl && this.iframeEl.dataset.src) {
      this.iframeEl.src = this.iframeEl.dataset.src;
      delete this.iframeEl.dataset.src;
      this.setState(true);
      return;
    }

    this.play();
  }

  play() {
    if (this.videoEl) {
      this.videoEl.play().catch(() => {
        this.videoEl.muted = true;
        this.videoEl.play().catch(() => {});
      });
      // setState fires from native 'play' event
    } else if (this.iframeEl) {
      const t = this.iframeEl.dataset.type;
      if (t === 'youtube') {
        this.iframeEl.contentWindow?.postMessage(
          '{"event":"command","func":"playVideo","args":""}', '*'
        );
      } else if (t === 'vimeo') {
        this.iframeEl.contentWindow?.postMessage(
          '{"method":"play"}', 'https://player.vimeo.com'
        );
      }
      this.setState(true);
    }
  }

  pause() {
    if (this.videoEl) {
      this.videoEl.pause();
      // setState fires from native 'pause' event
    } else if (this.iframeEl) {
      const t = this.iframeEl.dataset.type;
      if (t === 'youtube') {
        this.iframeEl.contentWindow?.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}', '*'
        );
      } else if (t === 'vimeo') {
        this.iframeEl.contentWindow?.postMessage(
          '{"method":"pause"}', 'https://player.vimeo.com'
        );
      }
      this.setState(false);
    }
  }

  setState(playing) {
    this.isPlaying = playing;
    this.classList.toggle('is-playing', playing);
    this.toggleBtn?.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    if (this.playIcon)  this.playIcon.style.display  = playing  ? 'none' : '';
    if (this.pauseIcon) this.pauseIcon.style.display = !playing ? 'none' : '';
  }
}

if (!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayer);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
